export default "__VITE_ASSET__BSgcJB0Y__"